export default "__VITE_ASSET__CSDoJP7F__"